module.exports = __webpack_public_path__ + "img/sidebar-expand.5c52b92f.svg";